import { FlexUnLockQuery, FlexUnLockCommandArgs } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { updateLockStatus } from '../../util/AssetsUtil';

export default class UnLockQuery {
  updateProgress = _.noop;

  constructor(updateProgress) {
    this.updateProgress = updateProgress;
  }

  run(inFuids, remotePath, assets) {
    const query = new FlexUnLockQuery();
    const message = new FlexUnLockCommandArgs();
    message.setInfuids(inFuids);
    message.setRemotePath(remotePath);
    query.message = message;
    //this.updateProgress(0, t('PLEASE_WAIT'), 'RUNNING');
    query
      .run()
      .then(
        (resp) => {
          this.updateProgress(100, resp.getMessage(), 'DONE');
          if (!resp.isSuccess()) ErrorHandler.handleError(resp.getMessage());
          else {
            updateLockStatus(assets, false);
          }
        },
        (failedResp) => {
          const error = failedResp.errorDetails ? failedResp.errorDetails : t('DEFAULT_ERROR_MSG');
          ErrorHandler.handleError(error);
          this.updateProgress(100, error, null, false);
        }
      )
      .finally(() => {
        if (this.updateProgress) {
          this.updateProgress(100, '', null, false);
        }
      });
  }
}
